import { React, Radio, FormControlLabel, Typography } from '../../utils/globalImports';

interface CustomRadioButtonProps {
  label?: string;               // The label for the radio button
  name?: string;
  value: string | number;               // The current value for the radio button
  checked: boolean;            // Whether the radio button is selected
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void; // Callback when radio button value changes
  required?: boolean;          // Optional prop to display an asterisk (*) for required fields
  disabled?: boolean;          // Optional prop to disable the radio button
  sx?: object;                 // Optional custom styling
}

const CustomRadioButton: React.FC<CustomRadioButtonProps> = ({
  label,
  name,
  value,
  checked,
  onChange,
  required = false,           // By default it's false, but can be true for required fields
  disabled = false,           // By default it's false, but can be set to true to disable the radio button
  sx,                         // For custom styling
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', ...sx }}>
      {/* Conditionally render the label with an asterisk for required fields */}
      <FormControlLabel
        control={
          <Radio
            value={value}
            name={name}
            checked={checked}
            onChange={onChange}
            color="primary"        // Change color on check
            disabled={disabled}    // Disable the radio button if 'disabled' is true
            size="small"
            sx={{ ml: 1 }}
          />
        }
        label={
          <Typography variant="body1" sx={{ display: 'inline', color: '#1e66ab', fontSize: '14px', fontWeight: 500 }}>
            {label}
          </Typography>
        }
      />
    </div>
  );
};

export default CustomRadioButton;
